function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["label", "placeholder", "inputPlaceholder", "noResultsText", "className", "inputValue", "onInputValueChange", "shouldFilter", "disabled", "error", "showSelectAll", "readOnly", "joinValues", "valueKey", "delimiter", "style", "selectedItems", "onChange", "onBlur", "id"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isEmpty } from "lodash";
import { BaseInput, BaseDivider } from "../../base";
import { ExpandMore, Search, Close } from "../../icons";
import { useRect } from "../../helpers/hooks";
import MultiDownshift from "./MultiDownshift";
import CheckboxIcon from "../checkboxicon/CheckboxIcon";
import Tag from "./Tag";
import { Label } from "../label/Label";
import { onEnter, onSpace, useId } from "../../helpers";
export var MAX_OPTIONS_HEIGHT = 254;
var INPUT_HEIGHT = 38;
var BORDER_HEIGHT = 1;
export var MAX_RESULTS_BOX_HEIGHT = MAX_OPTIONS_HEIGHT + INPUT_HEIGHT + BORDER_HEIGHT * 2;
function useControlledState(propsValue, onChange) {
  var _useState = useState(propsValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  function onValueChange(value) {
    if (onChange) onChange(value);else setValue(value);
  }
  useEffect(function () {
    if (propsValue !== value) setValue(propsValue);
  }, [propsValue]);
  return [value, onValueChange];
}
var stringifyValue = function stringifyValue(value) {
  return typeof value === "string" ? value : value !== null && JSON.stringify(value) || "";
};
var RenderHiddenFields = function RenderHiddenFields(_ref) {
  var name = _ref.name,
    joinValues = _ref.joinValues,
    valueKey = _ref.valueKey,
    disabled = _ref.disabled,
    delimiter = _ref.delimiter,
    selectedItems = _ref.selectedItems;
  if (!name) return /*#__PURE__*/React.createElement(React.Fragment, null);
  if (joinValues) {
    var value = selectedItems.map(function (i) {
      return stringifyValue(i[valueKey]);
    }).join(delimiter);
    return /*#__PURE__*/React.createElement("input", {
      disabled: disabled,
      name: name,
      type: "hidden",
      value: value
    });
  }
  return selectedItems.map(function (item, index) {
    return /*#__PURE__*/React.createElement("input", {
      disabled: disabled,
      key: "hidden.".concat(index),
      name: name,
      type: "hidden",
      value: stringifyValue(item[valueKey])
    });
  });
};
var MultiSelect = function MultiSelect(_ref2) {
  var _useRect;
  var label = _ref2.label,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? "Select option(s)..." : _ref2$placeholder,
    _ref2$inputPlaceholde = _ref2.inputPlaceholder,
    inputPlaceholder = _ref2$inputPlaceholde === void 0 ? "Search..." : _ref2$inputPlaceholde,
    _ref2$noResultsText = _ref2.noResultsText,
    noResultsText = _ref2$noResultsText === void 0 ? "No Results found." : _ref2$noResultsText,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$inputValue = _ref2.inputValue,
    inputValue = _ref2$inputValue === void 0 ? "" : _ref2$inputValue,
    onInputValueChange = _ref2.onInputValueChange,
    _ref2$shouldFilter = _ref2.shouldFilter,
    shouldFilter = _ref2$shouldFilter === void 0 ? true : _ref2$shouldFilter,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? "" : _ref2$error,
    _ref2$showSelectAll = _ref2.showSelectAll,
    showSelectAll = _ref2$showSelectAll === void 0 ? false : _ref2$showSelectAll,
    _ref2$readOnly = _ref2.readOnly,
    readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
    _ref2$joinValues = _ref2.joinValues,
    joinValues = _ref2$joinValues === void 0 ? false : _ref2$joinValues,
    _ref2$valueKey = _ref2.valueKey,
    valueKey = _ref2$valueKey === void 0 ? "value" : _ref2$valueKey,
    _ref2$delimiter = _ref2.delimiter,
    delimiter = _ref2$delimiter === void 0 ? "," : _ref2$delimiter,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    selectedItems = _ref2.selectedItems,
    onChange = _ref2.onChange,
    onBlur = _ref2.onBlur,
    id = _ref2.id,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldSetFocus = _useState4[0],
    setShouldSetFocus = _useState4[1];
  var _useControlledState = useControlledState(inputValue, onInputValueChange),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    searchText = _useControlledState2[0],
    setSearchText = _useControlledState2[1];
  var inputRef = useRef();
  var selectRef = useRef();
  var optionsRef = useRef();
  var rect = (_useRect = useRect(selectRef)) !== null && _useRect !== void 0 ? _useRect : {};
  var innerId = useId();
  var labelId = id || "tui-multi-select-".concat(innerId);
  useLayoutEffect(function () {
    var current = inputRef.current;
    if (current && shouldSetFocus) {
      current.focus();
      setShouldSetFocus(false);
    }
  }, [inputRef.current, shouldSetFocus]);
  function onRemove(item) {
    var items = _toConsumableArray(selectedItems);
    var index = items.findIndex(function (i) {
      return i.value === item.value;
    });
    items.splice(index, 1);
    onChange(items);
  }
  function onClearInput() {
    setSearchText("");
  }
  useLayoutEffect(function () {
    var inputMargin = 4;
    var styles = {
      top: "".concat(rect.top + rect.height + inputMargin, "px"),
      left: "".concat(rect.left, "px"),
      right: "".concat(rect.right, "px"),
      width: "".concat(rect.width, "px"),
      minHeight: "".concat(rect.height, "px"),
      transform: null,
      position: "fixed",
      height: null
    };
    var collidesWithBottom = window.innerHeight <= rect.bottom + MAX_RESULTS_BOX_HEIGHT;
    if (collidesWithBottom) {
      styles.transform = "translateY(-100%) translateY(-".concat(rect.height + inputMargin * 2, "px)");
      styles.height = "".concat(MAX_OPTIONS_HEIGHT, "px");
    }
    Object.entries(styles).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      optionsRef.current.style[key] = value;
    });
  }, [rect.top, rect.left, rect.right, rect.width, rect.height]);
  return /*#__PURE__*/React.createElement("div", {
    className: "multi-select ".concat(className, " ").concat(error ? "has-error" : "")
  }, /*#__PURE__*/React.createElement(MultiDownshift, {
    itemToString: function itemToString(item) {
      return item ? item.label : "";
    },
    selectedItems: selectedItems,
    onAdd: function onAdd(item) {
      onChange([].concat(_toConsumableArray(selectedItems), [item]));
    },
    onRemove: onRemove,
    onOuterClick: function onOuterClick(event) {
      if (onBlur) onBlur(event);
    }
  }, function (_ref5) {
    var getLabelProps = _ref5.getLabelProps,
      getInputProps = _ref5.getInputProps,
      getItemProps = _ref5.getItemProps,
      getMenuProps = _ref5.getMenuProps,
      isOpen = _ref5.isOpen,
      openMenu = _ref5.openMenu,
      closeMenu = _ref5.closeMenu,
      selectHighlightedItem = _ref5.selectHighlightedItem,
      setHighlightedIndex = _ref5.setHighlightedIndex;
    var options = props.options;
    if (shouldFilter) {
      options = options.filter(function (_ref6) {
        var _label$toUpperCase;
        var label = _ref6.label;
        return label === null || label === void 0 || (_label$toUpperCase = label.toUpperCase()) === null || _label$toUpperCase === void 0 ? void 0 : _label$toUpperCase.includes(searchText === null || searchText === void 0 ? void 0 : searchText.toUpperCase());
      });
    }
    function onExpand(e) {
      if (disabled || readOnly) return;
      e.preventDefault();
      e.stopPropagation();
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    }
    var allOptionsValues = options.map(function (item) {
      return item.value || 0;
    });
    var allSelectedValues = selectedItems.map(function (item) {
      return item.value || 0;
    });
    var allSelected = allOptionsValues.every(function (itemValue) {
      return allSelectedValues.includes(itemValue);
    });
    return /*#__PURE__*/React.createElement("div", {
      style: _objectSpread({
        position: "relative"
      }, style)
    }, label && /*#__PURE__*/React.createElement(Label, _extends({}, getLabelProps(), {
      htmlFor: labelId
    }), label), /*#__PURE__*/React.createElement("div", getInputProps({
      onClick: function onClick() {
        if (disabled || readOnly) return;
        openMenu();
        if (!isOpen) {
          setShouldSetFocus(true);
        }
      },
      className: classNames({
        "is-open": isOpen,
        disabled: disabled,
        "read-only": readOnly
      }),
      ref: selectRef
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "tag-wrapper"
    }, selectedItems.map(function (item) {
      return /*#__PURE__*/React.createElement(Tag, {
        key: item.value,
        onClose: function onClose() {
          return onRemove(item);
        }
      }, item.label);
    })), selectedItems.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "counter-wrapper"
    }, /*#__PURE__*/React.createElement(Tag, {
      className: "counter",
      onClose: function onClose() {
        return onChange([]);
      }
    }, "(", selectedItems.length, ")"))), /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: "0",
      className: "expand-icon",
      onClick: onExpand,
      onKeyPress: onExpand
    }, /*#__PURE__*/React.createElement(ExpandMore, null)), selectedItems.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "placeholder"
    }, placeholder)), /*#__PURE__*/React.createElement("div", {
      ref: optionsRef,
      className: "results-box"
    }, isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BaseInput, {
      ref: inputRef,
      fluid: true,
      icon: true,
      placeholder: inputPlaceholder,
      onChange: function onChange(e) {
        return setSearchText(e.target.value);
      },
      value: searchText,
      id: labelId
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        paddingLeft: 38
      }
    }), /*#__PURE__*/React.createElement("i", {
      className: "icon svg-wrapper",
      style: {
        left: 0
      }
    }, /*#__PURE__*/React.createElement(Search, null)), searchText && /*#__PURE__*/React.createElement("i", {
      role: "button",
      tabIndex: "0",
      className: "icon link svg-wrapper",
      onKeyPress: onEnter(onClearInput),
      onClick: onClearInput
    }, /*#__PURE__*/React.createElement(Close, {
      className: "close-icon"
    }))), options.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "no-results"
    }, noResultsText) : /*#__PURE__*/React.createElement("ul", getMenuProps({
      tabIndex: -1,
      onKeyPress: onSpace(function (e) {
        return e.stopPropagation();
      })
    }), /*#__PURE__*/React.createElement("li", {
      className: "select-all",
      role: "option",
      "aria-selected": "false"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: selectedItems.length === 0,
      onClick: function onClick() {
        return onChange([]);
      }
    }, "Clear Selection")), /*#__PURE__*/React.createElement(BaseDivider, null), showSelectAll ? /*#__PURE__*/React.createElement("li", {
      role: "option",
      "aria-selected": String(allSelected),
      tabIndex: 0,
      onClick: function onClick() {
        if (allSelected) onChange([]);else onChange(options);
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CheckboxIcon, {
      tabIndex: "-1",
      checked: allSelected
    }), /*#__PURE__*/React.createElement("span", null, "All"))) : /*#__PURE__*/React.createElement(React.Fragment, null), options.map(function (item, index) {
      var isSelected = selectedItems.findIndex(function (i) {
        return i.value === item.value;
      }) !== -1;
      return /*#__PURE__*/React.createElement("li", _extends({
        key: item.value
      }, getItemProps({
        item: item,
        index: index,
        onFocus: function onFocus() {
          setHighlightedIndex(index);
        },
        onKeyPress: onSpace(selectHighlightedItem, onEnter(selectHighlightedItem)),
        tabIndex: 0
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CheckboxIcon, {
        tabIndex: "-1",
        checked: isSelected
      }), /*#__PURE__*/React.createElement("span", null, item.label)));
    })))));
  }), error && !isEmpty(error) ? /*#__PURE__*/React.createElement("div", {
    className: "tui-invalid-feedback",
    children: error
  }) : "", /*#__PURE__*/React.createElement(RenderHiddenFields, _extends({
    selectedItems: selectedItems
  }, props)));
};
MultiSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  noResultsText: PropTypes.string,
  className: PropTypes.string,
  inputValue: PropTypes.string,
  onInputValueChange: PropTypes.func,
  shouldFilter: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  showSelectAll: PropTypes.bool,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  joinValues: PropTypes.bool,
  valueKey: PropTypes.string,
  delimiter: PropTypes.string,
  style: PropTypes.object
};
export default MultiSelect;
//# sourceMappingURL=MultiSelect.js.map